import React from "react";
import "./Campus.css";
// images
import img1 from "../../assets/images/campus/1.jpg";
import img2 from "../../assets/images/campus/2.jpg";
import img3 from "../../assets/images/campus/3.jpeg";
import img4 from "../../assets/images/campus/4.jpeg";

const Campus = () => {
  return (
    <>
      <section className="campus-section">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-12 col-md-12 mb-4 mb-lg-0">
              <div className="campus-title">
                <h2>
                    We Have Best Campus In The Region. Let's Explore The Campus.
                  </h2>
              </div>
            </div>
          </div>

          <div className="row mt-4 align-items-center">
            <div className="col-lg-3 col-md-12 mb-4 mb-lg-0">
              <div className="campus-img">
                <img src={img1} alt="Campus" className="" />
              </div>
            </div>
            
            <div className="col-lg-3 col-md-12 mb-4 mb-lg-0">
              <div className="campus-img">
                <img src={img2} alt="Campus" className="" />
              </div>
            </div>
            <div className="col-lg-3 col-md-12 mb-4 mb-lg-0">
              <div className="campus-img">
                <img src={img3} alt="Campus" className="" />
              </div>
            </div>
            <div className="col-lg-3 col-md-12 mb-4 mb-lg-0">
              <div className="campus-img">
                <img src={img4} alt="Campus" className="" />
              </div>
            </div>


          </div>
        </div>
      </section>
    </>
  );
};

export default Campus;
